import { Component, OnInit, Inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../../shared/services/user.service';
import { CaseService } from '../../../shared/services/case.service';

@Component({
  selector: 'app-edit-authorised-signatory',
  templateUrl: './edit-authorised-signatory.component.html',
  styleUrls: ['./edit-authorised-signatory.component.css']
})
export class EditAuthorisedSignatoryComponent implements OnInit {

  @Input() caseId?: number;
  @Input() authorisedSignatoryUserId?: number;

  selectedUserId?: number;
  users: any [] = [];
  updateDisabled: boolean = false;
  loading: boolean = false;

  constructor(public activeModal: NgbActiveModal,
              private caseService: CaseService,
              private userService: UserService) {}
              

  ngOnInit(): void {
    this.selectedUserId = this.authorisedSignatoryUserId;
    
    this.userService.authorisedSignatories().subscribe(result => {
      this.users = result;
    });
  }

  updateAuthorisedSignatory(){

    this.loading = true;
    this.caseService.updateAuthorisedSignatory(this.caseId, this.selectedUserId).subscribe((result: any) => {
      this.activeModal.close(true);
    });

  }

  validate(){

    /*
    if(this.selectedUserId !== null)
      this.updateDisabled = false;
    else
      this.updateDisabled = true;
      */
  }

}
